// ServiceWorker-side network timeout for GraphQL requests (apps/user/src/sw.ts).
//
// Deliberately NOT derived from VITE_API_FETCH_TIMEOUT_SEC: that value drives
// the client-side timeout in @lib/utils/customFetch, and the two are layered on
// the same request. The client starts its timer first, so if this one is equal
// or longer the client rejects before the ServiceWorker can serve its IndexedDB
// fallback - i.e. the offline cache would never be delivered. Keeping it short
// also matches the NetworkFirst `networkTimeoutSeconds: 3` strategy documented
// in apps/user/README_OFFLINE_MODE.md: fall back to cached data fast rather
// than leaving the user on a spinner.
//
// Named apart from customFetch's own `FETCH_TIMEOUT` on purpose: they are two
// different timeouts on the same request, and a file importing the wrong one
// silently inverts the layering described above.
export const SW_FETCH_TIMEOUT = 3000;

// Message the app throws (or aborts with) when it gives up on a request itself,
// rather than being told to by the server: the ServiceWorker's abort reason and
// the task-sync timeout both use it, and every app lists it in Sentry's
// `ignoreErrors`.
export const TIMEOUT_ERROR = 'TIMEOUT';

// `Error.name` that @lib/utils/customFetch stamps on its own timeout. It lives
// next to its near-namesake above so the difference is visible in one place:
// `TIMEOUT_ERROR` is a message, this is a name, and they are different strings.
export const FETCH_TIMEOUT_ERROR_NAME = 'FETCH_TIMEOUT';

// Prefix of the error `performServiceWorkerFetch` rejects with when the worker
// never answers its MessageChannel (apps/user/src/graphql-common/ApolloClient).
// Shared with `getStatusFromError`, which classifies it as a 503 - matching on
// a message only works while both sides agree on the wording.
export const SW_REQUEST_TIMEOUT_MESSAGE = 'ServiceWorker request timed out';
